import { jsPDF } from 'jspdf';

/**
 * Generates PDF report from calculation results
 * @param {Object} result - Full calculation result including costs
 * @param {Object} inputs - Original user inputs
 */
function generatePDF(result, inputs) {
  const doc = new jsPDF();
  
  // Header
  doc.setFontSize(20);
  doc.text('Bandwidth Planning Report', 20, 20);
  
  doc.setFontSize(12);
  doc.text(`Generated: ${new Date().toLocaleDateString()}`, 20, 30);
  
  // Scenario Summary
  doc.setFontSize(14);
  doc.text('Scenario Summary', 20, 45);
  
  doc.setFontSize(11);
  doc.text(`Users: ${inputs.userCount}`, 20, 55);
  doc.text(`Peak Concurrency: ${(inputs.peakConcurrency * 100).toFixed(0)}%`, 20, 62);
  doc.text(`Growth Projection: ${inputs.growthYears} years`, 20, 69);
  
  // Usage Profile
  doc.text('Usage Profile:', 20, 79);
  doc.text(`• Streaming: ${inputs.usageProfile.streaming}%`, 25, 86);
  doc.text(`• Gaming: ${inputs.usageProfile.gaming}%`, 25, 93);
  doc.text(`• Browsing: ${inputs.usageProfile.browsing}%`, 25, 100);
  doc.text(`• Video Calls: ${inputs.usageProfile.videoCalls}%`, 25, 107);
  
  // Bandwidth Results
  doc.setFontSize(14);
  doc.text('Bandwidth Requirements', 20, 122);
  
  doc.setFontSize(11);
  doc.text(`Base Bandwidth: ${result.baseBandwidth} Mbps`, 20, 132);
  doc.text(`With Overhead (25%): ${result.withOverhead} Mbps`, 20, 139);
  doc.text(`Future-Proofed: ${result.futureProofed} Mbps`, 20, 146);
  
  // Infrastructure
  doc.setFontSize(14);
  doc.text('Infrastructure Recommendation', 20, 161);
  
  doc.setFontSize(11);
  doc.text(`Type: ${result.infrastructure.description}`, 20, 171);
  doc.text(`Category: ${result.infrastructure.type}`, 20, 178);
  doc.text(`Max Capacity: ${result.infrastructure.maxCapacity} Mbps`, 20, 185);
  
  // Costs
  if (result.costs) {
    doc.setFontSize(14);
    doc.text(`Cost Estimate (${result.costs.planningPeriodYears} years)`, 20, 200);
    
    doc.setFontSize(11);
    doc.text(`Initial Investment: R ${result.costs.initialCosts.total.toLocaleString()}`, 20, 210);
    doc.text(`Monthly Recurring: R ${result.costs.recurringCosts.monthly}/month`, 20, 217);
    doc.text(`Total Cost of Ownership: R ${result.costs.summary.totalCostOfOwnership.toLocaleString()}`, 20, 224);
    doc.text(`Cost per Mbps: R ${result.costs.summary.costPerMbps}`, 20, 231);
    doc.text(`Setup Time: ${result.costs.summary.setupTime}`, 20, 238);
    
    // Notes
    doc.text('Notes:', 20, 248);
    result.costs.notes.forEach((note, index) => {
      doc.text(`• ${note}`, 25, 255 + (index * 7));
    });
  }
  
  // Footer
  doc.setFontSize(10);
  doc.text('Generated by Bandwidth Planner', 20, 280);
  
  // Download
  doc.save(`bandwidth-plan-${Date.now()}.pdf`);
}

export { generatePDF };